<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import URL from '@/views/sys/util/url'
  import UPDATE from '@/components/page/update.vue'
  import Qs from 'qs'
  import axios from 'axios'
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    methods: {
      checkbox(row){
        this.deleteIds = row.map(key => key.id).join(",");
      },
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "update"){
          this.$refs.childUpdate.open(row);
        }else if (clickName == "delete") {
            this.dataChanage(URL.domainMapping.del, {id: row.id}, res => {
                if (res.code == 0) {
                    this.$refs.childTable.defaultGetData(this.queryData);
                    this.$message.success("suc");
                } else {
                    this.$message.error(res.message);
                }
            });
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultQueryData(data);
        }else if("新增" == clickName){
          this.$refs.childUpdate.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        //根据是否包含id更新还是添加
        this.dataChanage((model.id!=undefined && model.id!=null && model.id!='') ? URL.domainMapping.edit:URL.domainMapping.save,model,res => {
        if (res.code == 0){
          this.$refs.childUpdate.close();
          this.$message.success("操作成功");
          this.$refs.childTable.defaultGetData(this.queryData);
        }else{

        }
      })
      },
      dataChanage(url,option,suc,fail){
        this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      }
    },
    data () {
      return {
        deleteIds:"",
        queryData:{},
        /*新增或更新*/
        updateData:{
          cols:[
                          { title: 'id', field: 'id',hidden:true},
                          { title: '域名', field: 'domain',required:true},
                          { title: '备注', field: 'remark'},
                      ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
              {click:"查询",auth:"sys:domainMapping:list"},
              {click:"新增",auth:"sys:domainMapping:save"}
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.domainMapping.list, //请求路径和参数
          selection: true,
          sequence: true,
          cols: [
                          { title: '主键', field: 'id'},
                          { title: '域名', field: 'domain'},
                          { title: '备注', field: 'remark'},
                          { title: '修改时间', field: 'updateDate'},
              {title:"操作",btnClick:[{name:"删除",click:"delete",type:"primary",icon:"el-icon-delete",auth:"sys:domainMapping:del"},{name:"修改",click:"update",type:"primary",icon: "el-icon-edit",auth:"sys:domainMapping:edit"}]},

          ]
        }
      }
    }
  }
</script>
